module.exports = __webpack_public_path__ + "static/media/stable-pane.a0518f6d.png";